import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import { GoalType } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { useGoalsFilterQuery } from './graphql/queries/generated/goalsFilter';

const getGoalFilterOption = ({ id, name }: Pick<GoalType, 'id' | 'name'>) => ({
  value: id,
  label: name,
});

const EDGE_KEY = 'goals';

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useGoalsFilterQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { goalIds: value } },
    getFilterOption: getGoalFilterOption,
  });

const useGoalOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useGoalsFilterQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { searchText: searchText } },
    getFilterOption: getGoalFilterOption,
  });

export const GoalEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useGoalOptionsQuery,
  useFilterValues,
};

export const GoalSingleEntityConfig: FilterBodyListConfig = {
  listVariant: 'single-ungrouped-infinite',
  useOptionsQuery: useGoalOptionsQuery,
  useFilterValues,
};
